/**
 * workToggle Module
 * Uses this pattern http://blog.teamtreehouse.com/how-to-write-a-module-in-javascript-quick-tip
 *
 * Overview:
 * Click events and animation timelines for
 *
 * Public Functions:
    fixedHero.init();
 */
/*exported primaryNavigation */

import $ from 'jquery';
import _ from 'underscore';
import PubSub from 'pubsub-js';

var MobileNav = function(){

  // Was `this` (window) under Browserify; ES modules are strict, so `this` is undefined here
  var self = {},
      $window = $(window),
      $body = $('body'),
      $html = $('html'),
      animateionSpeed = 0.5;

  self.lastScrollPosition = 0;

  self.initialize = function(){
    // Set Up Elements
    self.$navMobile = $('.js-nav-mobile');
    self.$navItemsContainer = self.$navMobile.find('.js-nav-items-container');
    self.$navLogo = self.$navMobile.find('.js-logo');
    self.$navMobileItems = self.$navMobile.find('.js-nav-item');

    // Set up event handlers
    $('.js-nav-toggle').click( self.toggleNav );

    // Subscribe to ScrollNav events
    PubSub.subscribe('beforeScrollToDestination', self.beforeScrollToDestination);

    console.log( 'MobileNav.init()' );
  };

  self.beforeScrollToDestination = function() {
    if( $html.hasClass( 'js-nav' ) ) {
      self.closeNav();
    }
  };

  self.windowResizeEventHandler = function( e ){
    var mobileNavHeight,
        windowHeight = $window.height();

    // Check if we should close the mobile nav
    if( self.$navMobile.is(":visible") === false ) {
      self.closeNav(true);
    }

    if( $html.hasClass( 'js-nav' ) ){
      // mobileNavHeight = self.$navMobile.actual( 'height' );
      mobileNavHeight = self.$navMobile.outerHeight();

      if ( mobileNavHeight < windowHeight ){
        mobileNavHeight = windowHeight;
      }

      $body.css({'height': mobileNavHeight });
    }
  };

  self.openNav = function(){
    var mobileNavHeight,
        windowHeight,
        timeline;
    // Show the nav
    $html.addClass( 'js-nav' );
    // Set height Variables
    mobileNavHeight = self.$navMobile.outerHeight();
    windowHeight = $window.height();
    self.lastScrollPosition = $window.scrollTop();

    if ( mobileNavHeight < windowHeight ){
      mobileNavHeight = windowHeight;
    }

    // Fade In
    timeline = new TimelineLite();
    timeline.fromTo( self.$navMobile, animateionSpeed,
      { opacity: 0 },
      { opacity: 1, ease: Power2.easeOut }, 'container' );
    timeline.eventCallback( "onComplete", animateInComplete );

    function animateInComplete() {
      // Give the nav absolute position
      self.$navMobile.css({
        'position': 'absolute'
      });

      // This has to be set for some reason
      $('body, html').css({
        'overflow-x': 'hidden'
      });

      // Set the height of the body to the navs
      // Prevent overflow
      $body.css({
        'height': mobileNavHeight,
        'overflow': 'hidden'
      });

      // Scroll to the top of the page
      $window.scrollTop( 0 );

      // Listen for resize
      $window.on('resize.MobileNav', _.throttle( self.windowResizeEventHandler, 400  ) );
    }
  };

  self.closeNav = function(disableAnimation) {
    var timeline;

    // Remove Resize Listener
    $window.off('resize.MobileNav');

    // Set the nav to fixed position & offset any scrolling
    self.$navMobile.css({
      'position': 'fixed',
      'top': $window.scrollTop() * -1
    });

    $body.attr('style', '');
    // self.$navMobile.attr('style', '');

    // Scroll back to last position
    $window.scrollTop( self.lastScrollPosition );

    if( disableAnimation ) {
      animateOutComplete();
    } else {
      // Fade Out
      timeline = new TimelineLite();
      timeline.fromTo( self.$navMobile, animateionSpeed,
        { opacity: 1 },
        { opacity: 0, ease: Power2.easeOut }, 'out -=0.15' );
      timeline.eventCallback( "onComplete", animateOutComplete);
    }

    function animateOutComplete() {
      // Hide mobile nav
      $html.removeClass( 'js-nav' );
      // Remove Styles
      self.$navMobile.attr('style', '');
    }

  };

  self.toggleNav = function( e ) {
    e.preventDefault();

    if( $html.hasClass( 'js-nav' ) ){
      self.closeNav();
    } else {
      self.openNav();
    }
  };

  self.initialize();

};

export default MobileNav();